<div class="{{data?.color}} bg-white p-4 rounded-lg">
  <div class="m-3">
    <h3>
      {{data?.title}}
    </h3>
  </div>

  <div>  
    <!-- mat-dialog-content -->
    {{data?.description}}
  </div>
  <div class="mt-3 flex flex-row gap-2">
    <!-- mat-dialog-actions  -->
    @switch (data?.dialogtype) {
      @case ('OkOnly') {
        <button class="button-base rounded-full" (click)="onClick('ok')" >{{'common.ok_dismiss' | translate}}</button>
      }
      @case ('YesNo') {
        <button class="button-base rounded-full bg-e-white text-e-dark-green" (click)="onClick('no')">{{'common.no_button' | translate}}</button>
        <button class="button-base rounded-full " (click)="onClick('yes')"  >{{'common.yes_button' | translate}}</button>
      }
      @case ('YesNoCancel') {
        <button class="button-base rounded-full bg-e-white text-e-dark-green" (click)="onClick('cancel')" >{{'common.cancel_button' | translate}}</button>
        <button class="button-base rounded-full bg-e-white text-e-dark-green" (click)="onClick('no')">{{'common.no_button' | translate}}</button>
        <button class="button-base rounded-full" (click)="onClick('yes')" >{{'common.yes_button' | translate}}</button> 
      }
      <!-- @case ('Custom') {
        <div class="">
          @for (btn of data?.custombuttons; track btn; let i = $index) {
            <button class="button-base rounded-full  me-2" [ngClass]="{'bg-e-white text-e-dark-green': i !== 0}" cdkFocusInitial="i === 0" [mat-dialog-close]="btn.value">{{btn.displayvalue | translate}}</button>
          }
        </div>
      } -->
    }
  </div>
</div>
